import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable import/prefer-default-export */

/* eslint-disable no-undef */

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-17 17:53:43
 * @LastEditTime: 2022-02-27 21:17:09
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React, { useState, useEffect } from 'react';
import { PLAN_ID } from '@/constants';
import ZaToast from '@/components/ZaToast';
import request from '@/utils/request';
import { useStore, dispatch } from '@/store';
import { getFetchBaseData } from '@/utils/utils';
import { getHashParam } from '@/utils/tool';
export const useNotice = ({
  noticeObjectType = 'insured',
  planId
}) => {
  const [notice, setNotice] = useState({});

  const _planId = useStore(PLAN_ID) || planId;

  useEffect(() => {
    const fn = async () => {
      if (!_planId) {
        return;
      }

      const data = getFetchBaseData() || {};
      const {
        certNo
      } = getHashParam() || {};
      if (certNo) data.extraInfo.currentInsuredFlag = certNo;
      const opts = {
        method: 'POST',
        data: _objectSpread(_objectSpread({}, data), {}, {
          planId: _planId,
          noticeObjectType
        })
      };
      const res = (await request('/v1/insure/queryNoticeQuestion', opts)) || {};
      const {
        code,
        message,
        result = {}
      } = res;

      if (Number(code)) {
        ZaToast.show(message || '系统异常，请稍后重试');
        return;
      }

      dispatch(`notice.${noticeObjectType}`, result);
      setNotice(result);
    };

    fn();
  }, [noticeObjectType, planId]);
  return [notice, setNotice];
};